module.exports = __webpack_public_path__ + "static/media/date-picker-arrow-right.3fea83bc.svg";